/* !
 * formProduct.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const value_sds = (FUNCTIONS.va.isEnglish) ? 'SDS (Safety Data Sheet) Request' : 'SDS';
	const value_sample = (FUNCTIONS.va.isEnglish) ? 'Sample Request' : '弊社サンプルのご要望';
	const value_suggestion = (FUNCTIONS.va.isEnglish) ? 'Offering' : '貴社からのご提案';

	// [入力画面] カテゴリで項目出し分け／「市区町村」「丁目・番地・建物名」必須出し分け
	const switchFields = () => {
		const catSelect = document.getElementById('select_category');
		const setField = (_ele) => {
			switch (_ele.value) {
				case value_sds:
					document.querySelectorAll('.__item[data-target]').forEach(ele => {
						ele.classList.remove(a);
					});
					document.querySelectorAll('.__item[data-target="category_sds"]').forEach(ele => {
						ele.classList.add(a);
					});

					if (FUNCTIONS.va.isEnglish === false) {
						document.querySelector('#field_address1 .__required').classList.add('di_none');
						document.querySelector('#field_address2 .__required').classList.add('di_none');
					}
					break;

				case value_sample:
					document.querySelectorAll('.__item[data-target]').forEach(ele => {
						ele.classList.remove(a);
					});
					document.querySelector('.__item[data-target="category_industry2"]').classList.add(a);
					document.querySelectorAll('.__item[data-target="category_sample"]').forEach(ele => {
						ele.classList.add(a);
					});
					if (FUNCTIONS.va.isEnglish === false) {
						document.querySelector('#field_address1 .__required').classList.remove('di_none');
						document.querySelector('#field_address2 .__required').classList.remove('di_none');
					}
					break;

				default:
					document.querySelectorAll('.__item[data-target]').forEach(ele => {
						ele.classList.remove(a);
					});
					document.querySelector('.__item[data-target="category_industry2"]').classList.add(a);
					document.querySelectorAll('.__item[data-target="category_other"]').forEach(ele => {
						ele.classList.add(a);
					});
					if (FUNCTIONS.va.isEnglish === false) {
						document.querySelector('#field_address1 .__required').classList.add('di_none');
						document.querySelector('#field_address2 .__required').classList.add('di_none');
					}
					break;
			}
			if (document.querySelector('.__suggestion')) {
				if (_ele.value.indexOf(value_suggestion) !== -1) {
					document.querySelector('.__suggestion').classList.remove('di_none');
				} else {
					document.querySelector('.__suggestion').classList.add('di_none');
				}
			}
		};
		setField(catSelect);
		catSelect.addEventListener('change', (e) => {
			setField(e.currentTarget);
		});

		// 大分類⇒中分類出し分け
		const industry1 = document.getElementById('select_industry1');
		const industry2 = document.getElementById('select_industry2');
		const setIndustry = (_ele) => {
			let target = industry1.querySelector(`option[value="${_ele.value}"]`).getAttribute('data-target');

			industry2.value = '';
			industry2.querySelectorAll('option').forEach(ele => {
				ele.disabled = true;
			});
			industry2.querySelectorAll(`option[data-target="${target}"]`).forEach(ele => {
				ele.disabled = false;
			});
		};
		setIndustry(industry1);
		industry1.addEventListener('change', (e) => {
			setIndustry(e.currentTarget)
		});

		// 確認画面から中分類引き継ぎ
		if (industry2.querySelector('option[selected]')) {
			industry2.value = industry2.querySelector('option[selected]').value;
		}
	}

	// [確認画面] カテゴリで項目出し分け／「市区町村」「丁目・番地・建物名」必須出し分け
	const switchFieldsConfirm = () => {
		const catSelect = document.querySelector('.category').textContent;
		switch (catSelect) {
			case value_sds:
				document.querySelectorAll('.__item[data-target]').forEach(ele => {
					ele.classList.remove(a);
				});
				document.querySelectorAll('.__item[data-target="category_sds"]').forEach(ele => {
					ele.classList.add(a);
				});
				if (FUNCTIONS.va.isEnglish === false) {
					document.querySelector('#field_address1 .__required').classList.add('di_none');
					document.querySelector('#field_address2 .__required').classList.add('di_none');
				}
				break;

			case value_sample:
				document.querySelectorAll('.__item[data-target]').forEach(ele => {
					ele.classList.remove(a);
				});
				document.querySelector('.__item[data-target="category_industry2"]').classList.add(a);
				document.querySelectorAll('.__item[data-target="category_sample"]').forEach(ele => {
					ele.classList.add(a);
				});
				if (FUNCTIONS.va.isEnglish === false) {
					document.querySelector('#field_address1 .__required').classList.remove('di_none');
					document.querySelector('#field_address2 .__required').classList.remove('di_none');
				}
				break;

			default:
				document.querySelectorAll('.__item[data-target]').forEach(ele => {
					ele.classList.remove(a);
				});
				document.querySelector('.__item[data-target="category_industry2"]').classList.add(a);
				document.querySelectorAll('.__item[data-target="category_other"]').forEach(ele => {
					ele.classList.add(a);
				});
				if (FUNCTIONS.va.isEnglish === false) {
					document.querySelector('#field_address1 .__required').classList.add('di_none');
					document.querySelector('#field_address2 .__required').classList.add('di_none');
				}
				break;
		}
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const formProductFUNCTIONS = () => {
		if (document.querySelector('.container.form-input')) {
			switchFields();
		}
		if (document.querySelector('.container.form-confirm')) {
			switchFieldsConfirm();
		}
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { formProductFUNCTIONS(); }) : formProductFUNCTIONS();

})(window.FUNCTIONS);
